module.exports = __webpack_public_path__ + "img/icon change password.0a8b9c5c.svg";